const HelpBlock = ({ title, body }: { title: string; body: string }) => (
  <div className="flex flex-col gap-[7px]">
    <p className="text-[14px] font-medium text-[#e88103]">{title}</p>
    <p className="text-[14px] leading-[1.3] text-[#616975]">{body}</p>
  </div>
);

export default HelpBlock;
